export default {
    loadGoogleAnalytics(trackingId) {
        if (process.env.VUE_APP_ENV !== 'production') {
            return
        }

        if (document.getElementById('google-analytics')) {
            return
        }

        const script = document.createElement('script')
        script.id = 'google-analytics'
        script.async = true
        script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`
        document.head.appendChild(script)

        script.onload = () => {
            window.dataLayer = window.dataLayer || []
            function gtag() {
                window.dataLayer.push(arguments)
            }
            window.gtag = gtag
            gtag('js', new Date())
            gtag('config', trackingId)
        }
    },
}
